module.exports = __webpack_public_path__ + "static/media/greenhouse2Step4-2.46446b9f.jpg";